import { FC, PropsWithChildren, Suspense } from 'react';
import { LayoutSpinner } from '@mybonum/ui';
import { Layout } from 'antd';
import { Outlet } from 'react-router';

import { UnauthorizedBody } from './components/body';
import { UnauthorizedFooter } from './components/footer';
import { UnauthorizedHeader } from './components/header';

import styles from './styles.module.scss';

import { useProfileContext } from '@/contexts/profile';
import { useAuthRedirect } from '@/hooks';

export const UnauthorizedLayout: FC<PropsWithChildren> = ({ children }) => {
    const { loading } = useProfileContext();

    useAuthRedirect();

    return (
        <Layout className={styles['layout']}>
            <UnauthorizedHeader />
            <UnauthorizedBody>
                {loading ? (
                    <LayoutSpinner />
                ) : (
                    <Suspense fallback={<LayoutSpinner />}>
                        <Outlet />
                        {children}
                    </Suspense>
                )}
            </UnauthorizedBody>
            <UnauthorizedFooter />
        </Layout>
    );
};
